import React from "react";
import PropTypes from 'prop-types';
import { DrawerNavigator, NavigationState, } from  "~/native-ui"

const getComponentFactory = (body) => {
    return class BodyComponent extends React.PureComponent {
        render() {
            return (
                <React.Fragment>
                    <NavigationState />
                    { body}
                </React.Fragment>
            );
        }
    }    
}



export class Drawer extends React.PureComponent {
    static propTypes = {
        showDrawer: PropTypes.bool,
        showAsHeader: PropTypes.bool,
        appBar: PropTypes.node.isRequired,
        body: PropTypes.node.isRequired,
    }

    get screens() {
        return [{
            name: "/",
            component: getComponentFactory(this.props.body)
        }]
    }
    
    renderAsDrawer() {
        const drawerNavigatorProps = {
            screens: this.screens,
            drawerContent: this.props.appBar,
            showDrawer: this.props.showDrawer,
        }
        return (
            <DrawerNavigator { ...drawerNavigatorProps } />
            //     {/* <View flexBasis={"50"}>
            //         { this.props.appBar }
            //     </View> */}
                // this.props.body
            // </DrawerNavigator>
        )
    }

    renderAsHeader() {
        return (
            <React.Fragment>
                { this.props.appBar }
                { this.props.body }
            </React.Fragment>
        )
    }

    
    render() {
        if (this.props.showAsHeader) {
            return this.renderAsHeader();
        }

        return this.renderAsDrawer();
    }
}